// dependency-graph-ignore-file
import { fieldToCollabJSON } from '@databases/collab/convert/to-collab';
import { type Database } from '@databases/model/database';

import { type DatabaseField, type DatabaseFieldType } from '../../types.ts';

interface AddFieldParams {
  field: DatabaseField<DatabaseFieldType>;
  index?: number;
}

export function addField(ydb: Database, { field, index }: AddFieldParams): void {
  ydb.mutate((db) => {
    if (index != null) {
      db.addFieldAt(field.id, fieldToCollabJSON(field, {}), index);
    } else {
      db.addFieldFromJSON(field.id, fieldToCollabJSON(field, {}));
    }

    db.views.forEach((viewId: string) => {
      if (db.viewsById[viewId] && db.viewsById[viewId].fields) {
        db.viewsById[viewId].setFieldVisibility(field.id, true, db.fields, {
          includeNewFieldInValidation: true
        });
      }
    });
  });
}
